import React from "react";
import { arrayToDate } from "assets/scripts/components/forms/formHelpers";
import { showCancelDisclosure } from "assets/scripts/domain/payment/paymentUtils";
import styles from "./Disclaimer.module.less";
import { FormattedMessage } from "react-intl";
const Disclaimer = ({ now, value, children }) => {
    const date = arrayToDate(value.date);
    const showDisclaimer = showCancelDisclosure(date, now);
    if (!showDisclaimer && children == null) {
        return null;
    }
    return (<div className={process.env.CLIENT === "CapOne" ? styles["left-align-disclaimer"] : styles.disclaimer}>
			{children}
			{showDisclaimer && (<FormattedMessage tagName="p" id="forms.payNow.disclaimer" defaultMessage={"A consumer may stop payment of a preauthorized electronic fund transfer from the consumer’s "
        + "account by notifying the financial institution orally or in writing at least three business "
        + "days before the scheduled transfer date or, by contacting the financial institution that "
        + "holds your Funding Account."}/>)}
		</div>);
};
export default Disclaimer;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/PayNowForm/Disclaimer/Disclaimer.tsx